const getKeyFormName = (key: string, name: string): string => {
    if (name === '') {
        return key;
    } else {
        return `${name}[${key}]`;
    }
};

const addUtmToFormData = (formData: FormData, name = ''): void => {
    const queryParams = Object.entries(new URLSearchParams(window.location.search));
    if (queryParams.length > 0) {
        for (const [key, value] of queryParams) {
            if (key === "utm_source" || key === "utm_campaign") {
                const formKeyName = getKeyFormName(key, name);
                formData.set(formKeyName, value);
            }
        }
    } else {
        const utmSource = window.localStorage.getItem("utm_source");
        const utmCampaign = window.localStorage.getItem("utm_campaign");

        if (utmSource !== null) {
            const formKeyName = getKeyFormName('utm_source', name);
            formData.set(formKeyName, utmSource);
        }

        if (utmCampaign !== null) {
            const formKeyName = getKeyFormName('utm_campaign', name);
            formData.set(formKeyName, utmCampaign);
        }
    }

};

const addQwamplifyToFormData = (formData: FormData, name = ''): void => {
    const qwamplifyKey = 'qwp_id';
    const qwp_id = new URLSearchParams(window.location.search).get(qwamplifyKey);
    if (qwp_id !== null) {
        const formKeyName = getKeyFormName(qwamplifyKey, name);
        formData.set(formKeyName, qwp_id);
    } else {
        const qwpIdSource = window.localStorage.getItem(qwamplifyKey);
        if (qwpIdSource !== null) {
            const formKeyName = getKeyFormName(qwamplifyKey, name);
            formData.set(formKeyName, qwpIdSource);
        }
    }

};

const autocompleteFromFieldName = (fieldName: string)  => {
    if (fieldName.startsWith('first') && fieldName.endsWith('name')) {
        return 'given-name';
    } else if (fieldName.startsWith('last') && fieldName.endsWith('name')) {
        return 'family-name';
    } else if (fieldName.includes('email')) {
        return'email';
    } else if (fieldName.includes('phone') || fieldName.includes('phone_custom') || fieldName.includes('phoneCustom')) {
        return'mobile';
    } else if (fieldName.includes('address') || fieldName.includes('street')) {
        return'address-line1';
    } else if (fieldName.includes('zip') || fieldName.includes('postalCode') || fieldName.includes('zipCode')) {
        return'postal-code';
    }
    return 'off';
};

const replaceFormNameByZero = (form: HTMLFormElement): void => {
    /**
     * Remplace toutes les  occurences  de "express_quotation_form3" par "express_quotation_form0"
     * dans les attributs [name] des inputs enfants du formulaire afin de
     * correspondre avec la déclaration faite dans le controller back
     */
    const formNumberKey = form.name.match(/\d+/);
    if (formNumberKey !== null) {
        form.name = form.name.replace(`${formNumberKey}`, '0');
        Array.from(form.querySelectorAll('[name^="express_"]')).forEach((element: Element) => {
            element.setAttribute('name', (element.getAttribute('name') as string).replace('form' + formNumberKey, 'form0'));
        });
    }
};

const activateFloatingLabel = (element: HTMLElement, activate: boolean) => {
    const inputGroup = element.closest('.input-group');
    if (!inputGroup || !(element instanceof HTMLInputElement)) {
        return;
    }

    if (activate) {
        inputGroup.classList.add('floating-label');
    } else if (element.value.trim() === '') {
        inputGroup.classList.remove('floating-label');
    }
}

export { addUtmToFormData, addQwamplifyToFormData, autocompleteFromFieldName, replaceFormNameByZero, activateFloatingLabel };
